module.exports = __webpack_public_path__ + "img/zimbabwe.1720b9b.webp";